var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button action-button",class:{
    '-loading': _vm.isLoading,
    '-primary': _vm.isPrimary,
    small: _vm.isSmall,
    disabled: _vm.disabled,
  },on:{"click":function($event){$event.preventDefault();return _vm.onClick($event)}}},[_c('moon-loader',{staticClass:"_state-spinner",attrs:{"color":'#ffffff',"size":_vm.spinnerSize}}),_vm._t("default"),(_vm.buttonText)?_c('span',{staticClass:"_button-text"},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }